import { toBase64 } from 'helpers/fileHelper';

export class ApiService {
  constructor(url, Request, history) {
    this.query = new Request(url, history);
  }

  // REPAIR CENTERS

  getRepairCenters = data => this.query.getData('repair-centers', data);
  getRepairCenterById = id => this.query.getData(`repair-centers/${id}`);
  createRepairCenter = data => this.query.postData('repair-centers', data);
  updateRepairCenter = (id, payload) =>
    this.query.patchData(`repair-centers/${id}`, payload);
  updateAllRepairCenters = (id, payload) =>
    this.query.putData('activate-shops', payload);
  importRepairCenters = async csvFile => {
    const fileBase64 = await toBase64(csvFile);
    return this.query.postData('repair-centers/import', { file: fileBase64 });
  };
  exportRepairCenters = () => this.query.getData('repair-centers/export');
  getCategories = () => this.query.getData('repair-centers/categories');
  getStrategies = () => this.query.getData('repair-centers/strategies');
  getSpecialDamages = () =>
    this.query.getData('repair-centers/special-damages');
  getManufacturers = () => this.query.getData('repair-centers/manufacturers');

  // RULES
  getRulesList = () => this.query.getData('rules?sort_by=createdAt&order=DESC');
  getRule = id => this.query.getData(`rules/${id}`);
  createRule = data => this.query.postData('rules', data);
  deleteRule = id => this.query.deleteData(`rules/${id}`);
  editRule = (id, payload) => this.query.patchData(`rules/${id}`, payload);

  // PARTNERS
  getRepairPartners = filters => this.query.getData('repair-partners', filters);
  getRepairPartnerById = id => this.query.getData(`repair-partners/${id}`);
  createRepairPartner = data => this.query.postData('repair-partners', data);
  // WORK ORDERS
  getWorkOrders = queryString =>
    this.query.getData('/work-orders', queryString);
  // WORK ORDER
  postWorkOrder = payload =>
    this.query.postData('/work-orders/search', payload);
  exportWorkOrders = queryString =>
    this.query.getData('/work-orders/export', queryString);
  getWorkOrder = id => this.query.getData(`work-orders/${id}`);
  exportWorkOrderPDF = (id, lang = 'en') =>
    this.query.getBlobData(`work-orders/${id}/export?lang=${lang}`);
  patchWorkOrder = (id, data) =>
    this.query.patchData(`work-orders/${id}`, data);
  getHistoricStatus = id => this.query.getData(`work-orders/${id}/history `);
  importWorkOrderStatuses = fileBase64 =>
    this.query.postData('work-orders/import-statuses', { file: fileBase64 });
  //DOCUMENTS WO
  uploadWODocuments = (id, documents) =>
    this.query.postMultiPart(`work-orders/${id}/documents`, documents);
  getDocuments = id => this.query.getData(`work-orders/${id}/documents`);
  // USER QUERIES
  getUserToken = credentials =>
    this.query.postDataWOToken('users/login', credentials);
  forgotPassword = credentials =>
    this.query.postDataWOToken('/users/forgot-password', credentials);
  getUserList = params => this.query.getData('users', params);
  createUser = data => this.query.postData('users/register', data);
  updateUser = data => this.query.patchData('/users/update', data);
  deleteUser = (id, data) => this.query.deleteData(`/users/${id}`, data);
  getUserById = id => this.query.getData(`users/${id}`);
  checkUserNameAvailable = name =>
    this.query.getData(`users/check-username/${name}`);
  //SPARE PARTS
  getSpareParts = queryString => this.query.getData('spare-part', queryString);
  addSparePart = data => this.query.postData('spare-part', data);
  //ARRANGEMENTS
  getArrangements = () => this.query.getData('arrangements');
  //REJECTIONS
  getRejectionReasons = () => this.query.getData('rejection-reason');
  getRejectionReasonsById = () => this.query.getData(`rejection-reason/${id}`);
  //CUSTOMERS
  getCustomers = () => this.query.getData(`customers`);
  //WEBHOOKS
  getWebhooks = params => this.query.getData('web-hooks', params);
  getWebhookById = id => this.query.getData(`web-hooks/${id}`);
  createWebhook = data => this.query.postData('web-hooks', data);
  editWebhook = (id, data) => this.query.patchData(`web-hooks/${id}`, data);
  //WEBHOOK ERRORS
  getWebhookErrors = params => this.query.getData('webhook-errors', params);
  patchWebhookError = (id, data) =>
    this.query.patchData(`webhook-errors/${id}`, data);
  //COMMENTS
  getCommentsWO = id => this.query.getData(`comments/workorder/${id}`);
  createComment = data => this.query.postData('comments', data);
  //LOGISTIC SERVICE
  getLogisticsList = queryString =>
    this.query.getData(`logistic-arrangements`, queryString);
  getLogisticsById = id => this.query.getData(`logistic-arrangements/${id}`);
  editLogistic = (id, data) =>
    this.query.patchData(`logistic-arrangements/${id}`, data);
  //LOGISTIC PARTNER
  getLogisticsPartnerList = queryString =>
    this.query.getData(`logistic-partners`, queryString);
  createLogisticPartner = data =>
    this.query.postData('logistic-partners', data);
  updateLogisticPartner = (id, data) =>
    this.query.patchData(`logistic-partners/${id}`, data);
  //LOGISTIC CENTERS
  getLogisticsCenterList = queryString =>
    this.query.getData(`logistic-centers`, queryString);
  getLogisticsCenterById = id => this.query.getData(`logistic-centers/${id}`);
  createLogisticCenter = data => this.query.postData('logistic-centers', data);
  updateLogisticCenter = (id, data) =>
    this.query.patchData(`logistic-centers/${id}`, data);
  importLogisticCenters = async csvFile => {
    const fileBase64 = await toBase64(csvFile);
    return this.query.postData('logistic-centers/import', { file: fileBase64 });
  };
  //DOCUMENTS LS
  uploadLSDocuments = (id, documents) =>
    this.query.postMultiPart(
      `logistic-arrangements/${id}/documents`,
      documents,
    );
  getDocumentsLS = id =>
    this.query.getData(`logistic-arrangements/${id}/documents`);
  //CONFIGURATION
  getConfiguration = (name, owner_id) =>
    this.query.getData(`configuration`, {
      owner_id,
      name,
    });
  //QUESTIONS
  getAnswers = question_type =>
    this.query.getData(`question-answer-options`, {
      question_type,
    });
  getQuestions = params => this.query.getData(`questions-answers`, params);
  patchSendAnswers = (questionId, data) =>
    this.query.patchData(`questions-answers/${questionId}`, data);
}
